// extracted by mini-css-extract-plugin
export default {"container":"ToggleCircle_container__Uzyl+","circle":"ToggleCircle_circle__caRhX"};